import Joi from 'joi';

import { type InviteMemberFormValues } from '@/domain/account/types';
import { PARTNER_INVITABLE_ROLES } from '@/domain/account/utils';
import { translatedMessages } from '@/i18n';

const NS = 'domain.account.schemas';

/** Mirrors `POST /partners/members/invites` (`partners.validations.ts`). */
export const inviteMemberSchema = Joi.object<InviteMemberFormValues>({
  email: Joi.string()
    .trim()
    .email({ tlds: { allow: false } })
    .max(254)
    .required()
    .error(
      translatedMessages(NS, {
        'string.empty': 'emailRequired',
        'any.required': 'emailRequired',
        'string.email': 'emailInvalid',
        'string.max': 'emailInvalid',
      }),
    ),
  role: Joi.string()
    .valid(...PARTNER_INVITABLE_ROLES)
    .required()
    .error(translatedMessages(NS, { 'any.only': 'roleRequired', 'any.required': 'roleRequired' })),
});
